// Source: https://gist.github.com/ghinda/8442a57f22099bdb2e34
export default function toFormData(obj, form, namespace) {
  const fd = form || new FormData();
  let formKey;

  for (const property in obj) {
    if (obj.hasOwnProperty(property) && obj[property] !== undefined) {
      const value = obj[property];
      if (namespace) {
        formKey = namespace + "[" + property + "]";
      } else {
        formKey = property;
      }

      if (value === null) {
        fd.append(formKey, "");
      } else if (value instanceof Date) {
        fd.append(formKey, value.toISOString());
      } else if (Array.isArray(value) && !value.find((x) => typeof x === "object")) {
        // If it's an array of scalar values, append it as array of values
        Array.prototype.forEach.call(value, (v) => fd.append(formKey + "[]", v));
      } else if (typeof value === "object" && !(value instanceof File)) {
        toFormData(value, fd, formKey);
      } else {
        fd.append(formKey, value);
      }
    }
  }

  return fd;
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/toFormData.js